import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import { getEquipmentServiceTypeList } from "../Actions/CommonAPI"; 
import { showLoader } from "../Actions/PageLoaderAPI";


export const putUpdateService = (data, id) => {
  const {t}=this.props;
  let url = `${API.PutServiceUpdate}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
       if( response.status===200){
        dispatch(getEquipmentServiceTypeList(id));
        dispatch({
          type: "PutServiceUpdateSuccess",
          data: response.data,
        });
        dispatch({
          type: "AttchmentUploaded",
          data: "",
        });
        toast.success(t('CommonText.CommonUpdate'), {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
      });
    }
      })
      .catch((error) => {
        dispatch({
          type: "PutServiceUpdateFailure",
          error: "ERROR",
        });
      });
  };
};
export const postUpdateServiceImages = (data) => {
  let url = `${API.PutServiceUpdateImages}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        // dispatch(showLoader());
        dispatch({
          type: "PutServiceUpdateSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "PutServiceUpdateFailure",
          error: "ERROR",
        });
      });
  };
};

export const getServiceSearchlist = (searchItem) => {
  var searchResult = [
    {
      shipId: 1,
      equipemtId: 1,
      equipmetName: "xxx",
      quantity: "1",
      "serviceType ": "annually",
      lastDone: "2000-01-01",
      nextDue: "2001-01-01",
      EquipmentType: "CO2",
      dateOfBuild: "2000-01-01",
      createdBy: "SNR",
      creatdeDate: "2000-01-01",
      modifiedBy: "SNR",
      modifiedDate: "2000-01-01",
    },
    {
      shipId: 1,
      equipemtId: 2,
      equipmetName: "yyy",
      quantity: "1",
      "serviceType ": "annually",
      lastDone: "2000-01-01",
      nextDue: "2001-01-01",
      EquipmentType: "CO2",
      dateOfBuild: "2000-01-01",
      createdBy: "SNR",
      creatdeDate: "2000-01-01",
      modifiedBy: "SNR",
      modifiedDate: "2000-01-01",
    },
  ];
  return (dispatch) => {
    dispatch({
      type: "GetServiceSearchSuccess",
      data: searchResult,
    });
  };

  //  let url = `${API.SearchShips}?IsClient=${searchItem.IsClient}&Annually=${searchItem.Annually}&Biannually=${searchItem.Biannually}&FiveYearly=${searchItem.FiveYearly}&Tenyearly=${searchItem.Tenyearly}`;

  // return dispatch => {
  //     axios.get(url)
  //         .then((response) => {
  //             dispatch({
  //                 type: "SearchShipsSuccess",
  //                 data: response.data,
  //             })
  //         })
  //         .catch((error) => {
  //             dispatch({
  //                 type: "SearchShipsFailure",
  //                 error: "ERROR"
  //             })
  //         })
  // }
};
